import {
  and,
  canCreate,
  canRead,
  canUpdate,
  isBrandEnv,
  isNeverVisible,
  isNotOfflineMode,
  isNotStore,
  isStoreEnv,
} from '../permissions/rules/visibility.combinators';
import { VisibilityRuleMap } from '../permissions/types/featureVisibility.types';
import { F, TargetsFeatureKey } from '../permissions/types/features.keys';

const canViewAllBrandTargets = canRead('all-brand-targets');

export const targetVisibilityRules: Pick<VisibilityRuleMap, TargetsFeatureKey> = {
  [F.targets.viewAll]: canViewAllBrandTargets,
  [F.targets.createCustomerTargets]: and(isBrandEnv, canCreate('targets')),
  [F.targets.createSalesRepresentativeTargets]: and(
    isBrandEnv,
    canCreate('targets'),
    canViewAllBrandTargets,
  ),
  [F.targets.createStoreTargets]: and(isStoreEnv, canCreate('targets')),
  [F.targets.editItems]: canUpdate('targets'),
  [F.targets.viewOrderTargets]: and(isNotStore, isNotOfflineMode, canRead('targets')),
  [F.targets.method]: isNeverVisible,
};
